/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Check/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Check({
  children,
  viewPath = "/DesignSystem/Svgs/Check",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 16,
  height = 16,
  fill = "none",
  stroke = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Check.Svg"
  data-view-path={viewPath}
 viewBox="0 0 16 16"
 style={{'--as-1-4GGpz': alignSelf,'--mt-2-4GGpz': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-4GGpz': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-4GGpz': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-4GGpz': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-4GGpz': opacity,'--w-7-4GGpz': typeof width === 'number' ? `${width}px` : width,'--h-8-4GGpz': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Check.SvgPath"
  data-view-path={viewPath}
 strokeWidth={2}
 strokeMiterlimit={10}
 d="M14.4 4l-8.3 8.2-4.5-4.5"
 style={{'--f-9-4GGpz': fill,'--s-10-4GGpz': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}